import { FC } from 'react';
import { Round2StockExchange } from '../components/Round2StockExchange';

interface StockDealProps {}

export const StockDeal: FC<StockDealProps> = () => {
  return <Round2StockExchange />;
};
